module.exports = __webpack_public_path__ + "img/icon-15.395780fd.png";